import { Component } from '@angular/core';
import { IzzyTicketNumberSequenceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ticket Number Sequences') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketnumbersequence-form',
    templateUrl: './izzyticketnumbersequence.form.component.html'
})
export class IzzyTicketNumberSequenceFormComponent extends BaseFormComponent {
    public record!: IzzyTicketNumberSequenceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'organizationSettings', sectionName: 'Organization Settings', isExpanded: true },
            { sectionKey: 'sequenceConfiguration', sectionName: 'Sequence Configuration', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

